// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.url-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 500px;
  padding: 0 20px;
}

.url-input {
  padding: 12px;
  font-size: 1rem;
  border: 2px solid #61dafb;
  border-radius: 4px;
  background: white;
  color: #282c34;
  width: 100%;
}

.submit-button {
  padding: 12px 24px;
  font-size: 1rem;
  background-color: #61dafb;
  border: none;
  border-radius: 4px;
  color: #282c34;
  cursor: pointer;
  transition: background-color 0.2s;
}

.submit-button:hover {
  background-color: #4fa8c7;
}

.error-message {
  color: #ff6b6b;
  margin: 1rem 0;
}

.screenshot-container {
  margin-top: 0;
  width: 100%;
}

.screenshot-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.submit-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.analysis-container {
  margin-top: 0;
  width: 100%;
  max-width: none;
  padding: 30px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  overflow-wrap: break-word;
}

.analysis-text {
  text-align: left;
  font-size: 1rem;
  line-height: 1.6;
  color: white;
}

.analysis-text h3 {
  color: #61dafb;
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-size: 1.4rem;
  border-bottom: 1px solid rgba(97, 218, 251, 0.3);
  padding-bottom: 0.5rem;
}

.analysis-text h3:first-child {
  margin-top: 0;
}

.analysis-text ul {
  padding-left: 1.5rem;
  margin: 1rem 0;
  list-style-type: none;
}

.analysis-text li {
  margin: 0.75rem 0;
  position: relative;
  padding-left: 1.5rem;
}

.analysis-text li:before {
  content: "•";
  color: #61dafb;
  position: absolute;
  left: 0;
}

.analysis-text p {
  margin: 1rem 0;
  line-height: 1.6;
}

.analysis-text strong {
  color: #61dafb;
  font-weight: 500;
}

.analysis-text em {
  opacity: 0.8;
  font-style: normal;
}

.results-container {
  width: 100%;
  max-width: 1400px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.results-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  width: 100%;
  margin: 2rem 0;
}

.screenshot-section, .analysis-section {
  width: 100%;
}

.screenshot-container {
  max-width: 400px;
  margin: 0 auto;
}

.screenshot-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.2s;
}

.screenshot-image:hover {
  transform: scale(1.02);
}

/* Desktop layout */
@media (min-width: 1024px) {
  .results-grid {
    grid-template-columns: minmax(300px, 400px) 1fr;
    align-items: start;
  }

  .screenshot-section {
    position: sticky;
    top: 2rem;
  }

  .analysis-container {
    margin-top: 0;
    height: 100%;
  }
}

h1 {
  margin-bottom: 0;
}

h2 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #61dafb;
}

.new-analysis-button {
  margin-top: 2rem;
  padding: 12px 24px;
  font-size: 1rem;
  background-color: #61dafb;
  border: none;
  border-radius: 4px;
  color: #282c34;
  cursor: pointer;
  transition: background-color 0.2s;
}

.new-analysis-button:hover {
  background-color: #4fa8c7;
}

.screenshot-preview {
  position: relative;
  max-height: 300px;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
}

.screenshot-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}

.expand-button {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: white;
  border: none;
  cursor: pointer;
  text-align: center;
  font-size: 0.9rem;
  opacity: 0;
  transition: opacity 0.2s;
}

.screenshot-preview:hover .expand-button {
  opacity: 1;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 2rem;
}

.modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
  background: #282c34;
  border-radius: 8px;
  padding: 1rem;
}

.modal-image {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.close-modal {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: #61dafb;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #282c34;
  transition: background-color 0.2s;
}

.close-modal:hover {
  background-color: #4fa8c7;
}

.previous-analyses {
  margin-top: 3rem;
  width: 100%;
  max-width: 800px;
}

.analyses-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.analysis-item {
  background: rgba(255, 255, 255, 0.1);
  padding: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.analysis-item:hover {
  background: rgba(255, 255, 255, 0.15);
}

.analysis-url {
  font-size: 1rem;
  color: #f97316;
  margin-bottom: 0.5rem;
  word-break: break-all;
}

.analysis-time {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
}

@keyframes subtleGradientRed {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes subtleGradientGreen {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.problem-card {
  background: linear-gradient(120deg, #0A0A0A 0%, rgba(255, 0, 0, 0.03) 100%);
  background-size: 200% 200%;
  animation: subtleGradientRed 15s ease infinite;
  transition: border-color 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.problem-card:hover {
  border-color: rgba(255, 0, 0, 0.2);
}

.solution-card {
  background: linear-gradient(120deg, #0A0A0A 0%, rgba(0, 255, 0, 0.03) 100%);
  background-size: 200% 200%;
  animation: subtleGradientGreen 15s ease infinite;
  transition: border-color 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.solution-card:hover {
  border-color: rgba(0, 255, 0, 0.2);
} `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE;IACE,+CAA+C;IAC/C,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,2EAA2E;EAC3E,0BAA0B;EAC1B,8CAA8C;EAC9C,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2EAA2E;EAC3E,0BAA0B;EAC1B,gDAAgD;EAChD,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.url-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n  max-width: 500px;\n  padding: 0 20px;\n}\n\n.url-input {\n  padding: 12px;\n  font-size: 1rem;\n  border: 2px solid #61dafb;\n  border-radius: 4px;\n  background: white;\n  color: #282c34;\n  width: 100%;\n}\n\n.submit-button {\n  padding: 12px 24px;\n  font-size: 1rem;\n  background-color: #61dafb;\n  border: none;\n  border-radius: 4px;\n  color: #282c34;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.submit-button:hover {\n  background-color: #4fa8c7;\n}\n\n.error-message {\n  color: #ff6b6b;\n  margin: 1rem 0;\n}\n\n.screenshot-container {\n  margin-top: 0;\n  width: 100%;\n}\n\n.screenshot-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.submit-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.analysis-container {\n  margin-top: 0;\n  width: 100%;\n  max-width: none;\n  padding: 30px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  overflow-wrap: break-word;\n}\n\n.analysis-text {\n  text-align: left;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: white;\n}\n\n.analysis-text h3 {\n  color: #61dafb;\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n  font-size: 1.4rem;\n  border-bottom: 1px solid rgba(97, 218, 251, 0.3);\n  padding-bottom: 0.5rem;\n}\n\n.analysis-text h3:first-child {\n  margin-top: 0;\n}\n\n.analysis-text ul {\n  padding-left: 1.5rem;\n  margin: 1rem 0;\n  list-style-type: none;\n}\n\n.analysis-text li {\n  margin: 0.75rem 0;\n  position: relative;\n  padding-left: 1.5rem;\n}\n\n.analysis-text li:before {\n  content: \"•\";\n  color: #61dafb;\n  position: absolute;\n  left: 0;\n}\n\n.analysis-text p {\n  margin: 1rem 0;\n  line-height: 1.6;\n}\n\n.analysis-text strong {\n  color: #61dafb;\n  font-weight: 500;\n}\n\n.analysis-text em {\n  opacity: 0.8;\n  font-style: normal;\n}\n\n.results-container {\n  width: 100%;\n  max-width: 1400px;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.results-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2rem;\n  width: 100%;\n  margin: 2rem 0;\n}\n\n.screenshot-section, .analysis-section {\n  width: 100%;\n}\n\n.screenshot-container {\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.screenshot-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.screenshot-image:hover {\n  transform: scale(1.02);\n}\n\n/* Desktop layout */\n@media (min-width: 1024px) {\n  .results-grid {\n    grid-template-columns: minmax(300px, 400px) 1fr;\n    align-items: start;\n  }\n\n  .screenshot-section {\n    position: sticky;\n    top: 2rem;\n  }\n\n  .analysis-container {\n    margin-top: 0;\n    height: 100%;\n  }\n}\n\nh1 {\n  margin-bottom: 0;\n}\n\nh2 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: #61dafb;\n}\n\n.new-analysis-button {\n  margin-top: 2rem;\n  padding: 12px 24px;\n  font-size: 1rem;\n  background-color: #61dafb;\n  border: none;\n  border-radius: 4px;\n  color: #282c34;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.new-analysis-button:hover {\n  background-color: #4fa8c7;\n}\n\n.screenshot-preview {\n  position: relative;\n  max-height: 300px;\n  overflow: hidden;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.screenshot-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s;\n}\n\n.expand-button {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 1rem;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));\n  color: white;\n  border: none;\n  cursor: pointer;\n  text-align: center;\n  font-size: 0.9rem;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.screenshot-preview:hover .expand-button {\n  opacity: 1;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 2rem;\n}\n\n.modal-content {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow: auto;\n  background: #282c34;\n  border-radius: 8px;\n  padding: 1rem;\n}\n\n.modal-image {\n  width: 100%;\n  height: auto;\n  border-radius: 4px;\n}\n\n.close-modal {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: #61dafb;\n  border: none;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #282c34;\n  transition: background-color 0.2s;\n}\n\n.close-modal:hover {\n  background-color: #4fa8c7;\n}\n\n.previous-analyses {\n  margin-top: 3rem;\n  width: 100%;\n  max-width: 800px;\n}\n\n.analyses-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.analysis-item {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.analysis-item:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.analysis-url {\n  font-size: 1rem;\n  color: #f97316;\n  margin-bottom: 0.5rem;\n  word-break: break-all;\n}\n\n.analysis-time {\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n@keyframes subtleGradientRed {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@keyframes subtleGradientGreen {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.problem-card {\n  background: linear-gradient(120deg, #0A0A0A 0%, rgba(255, 0, 0, 0.03) 100%);\n  background-size: 200% 200%;\n  animation: subtleGradientRed 15s ease infinite;\n  transition: border-color 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.problem-card:hover {\n  border-color: rgba(255, 0, 0, 0.2);\n}\n\n.solution-card {\n  background: linear-gradient(120deg, #0A0A0A 0%, rgba(0, 255, 0, 0.03) 100%);\n  background-size: 200% 200%;\n  animation: subtleGradientGreen 15s ease infinite;\n  transition: border-color 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.solution-card:hover {\n  border-color: rgba(0, 255, 0, 0.2);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
